import { IDatabaseMigration } from "client/Database/migrator";

export const initDatabase: IDatabaseMigration = {
	upgrade(database: IDBDatabase): void {
		database.createObjectStore("zustandStores", { keyPath: "name" });
	}
};